import { AssistantFilled, Info } from "@clockwise/icons";
import { CardIcon } from "@clockwise/web-commons/src/ui/card";
import { Tooltip } from "@material-ui/core";
import classNames from "classnames";
import React from "react";

type Props = {
  title?: string | JSX.Element;
  description?: string | JSX.Element;
  onClick?: () => void;
  warning?: boolean;
  muted?: boolean;
  badged?: boolean;
  tooltipText?: string | JSX.Element;
  emphasis?: boolean;
};

export function AutopilotStatusCard({
  title,
  description,
  onClick,
  warning = false,
  muted = false,
  badged = false,
  emphasis = false,
  tooltipText,
}: Props) {
  const textColorClass = emphasis
    ? "cw-text-onEmphasis"
    : warning
    ? "cw-text-warning"
    : "cw-text-brand";

  const tooltip = !!tooltipText && (
    <Tooltip placement="top" title={tooltipText} classes={{ popper: "cw-max-w-[168px]" }}>
      <Info className="cw-w-[14px] cw-h-[14px] cw-text-subtle" />
    </Tooltip>
  );

  return (
    <CardIcon
      badged={badged}
      onClick={onClick}
      Icon={AssistantFilled}
      iconProps={{ className: textColorClass }}
      emphasis={emphasis}
    >
      <div
        className={classNames(
          "cw-heading-sm cw-flex cw-items-center cw-gap-1",
          muted ? "cw-text-muted" : textColorClass,
        )}
      >
        {title}
        {title && tooltip}
      </div>
      <div
        className={classNames("cw-body-sm cw-flex cw-items-center", {
          "cw-text-onEmphasis": emphasis,
        })}
      >
        {description}
        {!title && tooltip}
      </div>
    </CardIcon>
  );
}
